export default "__VITE_ASSET__B71Tew4j__"